import { defaultAdherenceParams } from '@/utils/metricsParams';
import { MetricsSection } from './MetricsSection';
import { api } from '@/store/api';
import { ADHERENCE_GROUPINGS } from '@/types/agentEvents';

const { useGetAdherenceMetricsQuery } = api;

export function AgentAdherenceSection() {
  return (
    <MetricsSection
      titleKey="components.dashboard.agentAdherence"
      descriptionKey="components.dashboard.agentAdherenceDescription"
      metricName="adherence"
      defaultParams={defaultAdherenceParams()}
      useQuery={useGetAdherenceMetricsQuery}
      groupingsOptions={ADHERENCE_GROUPINGS}
      refreshLabelKey="components.dashboard.refreshAdherence"
    />
  );
}
